import styled from "styled-components";

export const EventScheduleFilterItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  padding: 9px 12px;
  gap: 5px;
  border: 1px solid var(--Black-200, #b7b7b7);
  font-weight: 600;
  font-size: 12px;
  position: relative;
  height: 30px;
`;

export const EventScheduleFilterList = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 12px;
  gap: 4px;
  z-index: 100;
  top: 38px;
  right: 0px;
  box-shadow: 0px 0px 8px 0px #0000001f;

  > .item {
    height: 30px;
    border-radius: 15px;
    padding: 8px 12px;
    border: 1px solid var(--Black-100, #f0f0f0);
    font-weight: 600;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    color: var(--Black-500, #202020);
    white-space: nowrap;
  }
  > .select {
    background: var(--Purple-300, #6436e7);
    color: #fff;
  }
`;
